module.exports = __webpack_public_path__ + "img/car-inside-first.8395911b.jpg";